import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { SUBSIDIARIES } from "@/lib/content";
import { subsidiaryLogo } from "@/lib/assets";

export default function GroupCompanies() {
  return (
    <section id="companies" data-testid="companies-section" className="relative bg-offwhite py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20">
        <div className="max-w-3xl mb-16">
          <div className="flex items-center gap-3 mb-5">
            <span className="gold-hairline" />
            <span className="text-gold text-xs uppercase tracking-[0.28em] font-medium">02 — Our Companies</span>
          </div>
          <h2 className="font-serif text-navy text-3xl md:text-4xl lg:text-5xl font-light leading-[1.1] tracking-[-0.01em]">
            A <em className="text-gold not-italic">diversified</em> group of professional services companies.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {SUBSIDIARIES.map((s, idx) => {
            const isReal = s.logo_kind === "real";
            return (
              <article
                key={s.slug}
                data-testid={`company-card-${s.slug}`}
                className="group relative bg-white border border-softgray p-8 md:p-10 flex flex-col
                           hover:border-gold hover:shadow-[0_20px_60px_-20px_rgba(15,42,92,0.18)]
                           transition-[border-color,box-shadow,transform] duration-500 hover:-translate-y-1"
              >
                <div className="absolute top-6 right-6 text-[11px] text-mutedink font-mono tabular-nums">
                  0{idx + 1}
                </div>

                {isReal ? (
                  <>
                    {/* Featured real logo */}
                    <div className="h-[90px] md:h-[100px] lg:h-[120px] px-4 flex items-center justify-center mb-6">
                      <img
                        src={subsidiaryLogo(s)}
                        alt={`${s.name} logo`}
                        className="max-h-full max-w-full w-auto object-contain transition-transform duration-500 group-hover:scale-105"
                        loading="lazy"
                        decoding="async"
                      />
                    </div>
                    <div className="w-10 h-[1.5px] bg-gold mb-4 mx-auto" />
                    <h3 className="font-serif text-navy text-xl leading-tight text-center mb-3">
                      {s.name}
                    </h3>
                    <p className="text-mutedink text-[14px] leading-relaxed font-light text-center min-h-[3.5rem]">
                      {s.description}
                    </p>
                    <div className="mt-6 flex justify-center">
                      <Link
                        to={`/companies/${s.slug}`}
                        className="inline-flex items-center gap-2 text-navy text-xs uppercase tracking-[0.18em] font-semibold group-hover:text-gold transition-colors"
                        data-testid={`company-link-${s.slug}`}
                      >
                        Learn More
                        <ArrowUpRight size={14} strokeWidth={2} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                      </Link>
                    </div>
                  </>
                ) : (
                  <>
                    {/* Auto-generated lockup */}
                    <img
                      src={subsidiaryLogo(s)}
                      alt={`${s.name} — a Salihi Group company`}
                      className="w-full max-w-[280px] h-auto mb-6"
                      loading="lazy"
                      decoding="async"
                    />
                    <div className="w-10 h-[1.5px] bg-gold mb-5" />
                    <p className="text-mutedink text-[15px] leading-relaxed font-light min-h-[3.5rem]">
                      {s.description}
                    </p>
                    <Link
                      to={`/companies/${s.slug}`}
                      className="mt-7 inline-flex items-center gap-2 text-navy text-xs uppercase tracking-[0.18em] font-semibold group-hover:text-gold transition-colors"
                      data-testid={`company-link-${s.slug}`}
                    >
                      Learn More
                      <ArrowUpRight size={14} strokeWidth={2} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </Link>
                  </>
                )}
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
